module.exports = __webpack_public_path__ + "img/peru-libre.478568a7.png";